export const GetStatus = {
  alert: 'warning',
  critical: 'error',
};
